<template>
  <div>
    <v-navigation-drawer v-model="drawer" app clipped width="300px">
      <v-list-item>
        <v-list-item-avatar>
          <v-icon>mdi-face</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ user.displayName}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="logout">
            <v-icon>mdi-eject</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider />
      <v-list>
        <template v-for="menuItem in menuItems">
          <MenuItem
              :menu-item="menuItem" :key="menuItem.title"
              v-if="(!menuItem.caslSubject || $can('access', menuItem.caslSubject)) && (!menuItem.feature || accountCan(account, menuItem.feature))"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="left" temporary fixed></v-navigation-drawer>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MenuItem from "@components/mainNav/MenuItem.vue";
import {accountCan} from "@/utils/account.utils";

export default {
  components: {MenuItem},
  props: { value: { type: Boolean } },
  computed: {
    ...mapGetters('account', ['account']),
    ...mapGetters('middleware', {menuItems: 'leftNav'}),
    user: function() {
      return this.$store.getters["auth/currentUser"];
    }
  },
  data() {
    return {
      left: false,
      drawer: this.value,
    };
  },
  watch: {
    value: function() {
      this.drawer = this.value;
    },
    drawer: function() {
      this.$emit("input", this.drawer);
    },
    $route: {
      handler() {
        this.$emit("input", false);
      },
      deep: true
    }
  },
  mounted() {
    this.getLeftnav()
  },
  methods: {
    accountCan,
    ...mapActions('middleware', {getLeftnav: 'leftNav'}),
    logout() {
      this.$store
          .dispatch("auth/logout")
          .then(() => this.$router.replace({ name: "Login" }));
    },
  }
};
</script>
